import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Button } from '../ui/button'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export function LogoutConfirmDialog({ isOpen, onClose, onConfirm }: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent data-testid="logout-confirm-modal">
        <DialogHeader>
          <DialogTitle>Wylogowanie</DialogTitle>
          <DialogDescription>
            Czy na pewno chcesz się wylogować?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button data-testid="logout-cancel-button" variant="outline" onClick={onClose}>
            Anuluj
          </Button>
          <Button data-testid="logout-confirm-button" variant="destructive" onClick={onConfirm}>
            Wyloguj
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
} 